var socialPopups = {

	elms: {
		footerSocialLinks: $('.footer-social-links ul a')
	},

	openInPopUp: function( e ) {
		var $target = $(e.target);
		var href = $target.attr('href');
		var title = $target.attr('title');

		window.open(href, title, "width=500,height=500");
	},

	eventListeners: function() {
		socialPopups.elms.footerSocialLinks.on('click', function( e ) {
			e.preventDefault();
			socialPopups.openInPopUp( e );
		});
	},

	init: function() {
		socialPopups.eventListeners();
	}
};